export default __webpack_public_path__ + "static/media/Grnwrk.415e2c1f.jpg";